// BHP-1070: dependency-inversion seam for the customer feature. Application
// hooks read the gateway from context; the default is the real Backend2.0
// adapter, and tests override it via <CustomerGatewayProvider value={...}>.
import { createContext, useContext } from 'react';
import type { CustomerGateway } from '../domain/customerGateway';
import { customerApiAdapter } from '../infrastructure/customerApiAdapter';

const CustomerGatewayContext =
  createContext<CustomerGateway>(customerApiAdapter);

export const CustomerGatewayProvider = CustomerGatewayContext.Provider;

export function useCustomerGateway(): CustomerGateway {
  return useContext(CustomerGatewayContext);
}
